import {
  ActionNames,
  EditActionDefinition,
} from '@wix/editor-platform-host-integration-apis';
import { Actions } from '@wix/component-protocol/schema';
import {
  resolvePlatformActionsWithFactories,
  resolveHostActionsWithFactories,
} from '../utils';
import { EditActionsStore } from '../editActionsStore';
import { PlatformContext, PlatformEditAction } from '../types';

function getResolvedPlatformEditActions<
  TActionDefinition extends EditActionDefinition = EditActionDefinition,
>(
  manifestActions: Actions,
  platformContext: PlatformContext,
): TActionDefinition[] {
  return resolvePlatformActionsWithFactories<TActionDefinition>(
    EditActionsStore.getStoreSlice<PlatformEditAction>(
      Object.keys(manifestActions) as ActionNames[],
    ),
    manifestActions,
    platformContext,
  );
}

function getResolvedHostEditActions<
  TActionDefinition extends EditActionDefinition = EditActionDefinition,
>(
  manifestActions: Actions,
  platformContext: PlatformContext,
): TActionDefinition[] {
  return resolveHostActionsWithFactories<TActionDefinition>(
    EditActionsStore.getStoreSlice(
      Object.keys(manifestActions) as ActionNames[],
    ),
    manifestActions,
    platformContext,
  );
}

export { getResolvedHostEditActions, getResolvedPlatformEditActions };
